import {useDispatch, useSelector} from 'react-redux';
import {SelectInput} from '../../utils/SelectInput';
import {useEffect, useState} from 'react';
import {prepareDatosAuxOptions, responseSelector} from '../../utils/utils';
import {getRubrosDuck, getRubrosThunk} from '../../oportunidades/duck';

export const SelectRubros = ({token, onError, rubroOption, setRubroOption}) => {
  const dispatch = useDispatch();
  const [rubrosOptions, setRubrosOptions] = useState([]);
  const modelGetRubros = useSelector(state => state.getRubros);

  useEffect(() => {
    const {data, error} = responseSelector(modelGetRubros);

    if (error) {
      onError?.(error);
      dispatch(getRubrosDuck.actions.clear());
    }

    if (data) {
      const datosAuxOptions = prepareDatosAuxOptions(data.items);
      setRubrosOptions(datosAuxOptions);
      dispatch(getRubrosDuck.actions.clear());
    }
  }, [modelGetRubros]);

  useEffect(() => {
    dispatch(
      getRubrosThunk({
        userToken: token.raw,
      }),
    );
  }, []);

  return (
    <SelectInput
      label="Rubro"
      value={rubroOption}
      options={rubrosOptions}
      setValue={setRubroOption}
      isMulti={true}
      maxMultiSelection={10}
    />
  );
};
